import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Statistics from './Statistics';
import GraduatedStudentsPerStudyCycle from './GraduatedStudentsPerStudyCycle';
import GraduatedStudentsPerStudyCycleForUniversity from './GraduatedStudentsPerStudyCycleForUniversity';
import GraduatedStudentsPerFaculty from './GraduatedStudentsPerFaculty';
import EnrolledStudentsPerStudyCycle from './EnrolledStudentsPerStudyCycle';
import EnrolledStudentsPerStudyCycleForUniversity from './EnrolledStudentsPerStudyCycleForUniversity';
import EnrolledStudentsPerStudyType from './EnrolledStudentsPerStudyType';
import EnrolledStudentsPerStudyTypeForUniversity from './EnrolledStudentsPerStudyTypeForUniversity';
import GraduatedPerStudyCycleAndGender from './GraduatedPerStudyCycleAndGender';
import EnrolledStudentsPerCountries from './EnrolledStudentsPerCountries';
import EnrolledStudentsPerCountriesForUniversity from './EnrolledStudentsPerCountriesForUniversity';
import EnrolledStudentsPerMunicipalityForBiH from './EnrolledStudentsPerMunicipalityForBiH';
import EnrolledStudentsPerMunicipalityForBiHForUniversity from './EnrolledStudentsPerMunicipalityForBiHForUniversity';
import EnrolledStudentsPerStudyYearAndCycle from './EnrolledStudentsPerStudyYearAndCycle';
import EnrolledStudentsPerStudyYearAndCycleForUniversity from './EnrolledStudentsPerStudyYearAndCycleForUniversity';


export default class Router extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div>
                <Switch>
                    <Route exact path="/statistika" component={Statistics} />
                    <Route path="/statistika/diplomirani-po-ciklusima" component={GraduatedStudentsPerStudyCycle} />
                    <Route path="/statistika/diplomirani-po-ciklusima-za-univerzitet" component={GraduatedStudentsPerStudyCycleForUniversity} />
                    <Route path="/statistika/diplomirani-po-fakultetima" component={GraduatedStudentsPerFaculty} />
                    <Route path="/statistika/upisani-po-ciklusima" component={EnrolledStudentsPerStudyCycle} />
                    <Route path="/statistika/upisani-po-ciklusima-za-univerzitet" component={EnrolledStudentsPerStudyCycleForUniversity} />
                    <Route path="/statistika/upisani-prema-statusu-studiranja" component={EnrolledStudentsPerStudyType} />
                    <Route path="/statistika/upisani-prema-statusu-studiranja-za-univerzitet" component={EnrolledStudentsPerStudyTypeForUniversity} />
                    <Route path="/statistika/diplomirani-prema-spolu" component={GraduatedPerStudyCycleAndGender} />
                    <Route path="/statistika/upisani-po-drzavama" component={EnrolledStudentsPerCountries} />
                    <Route path="/statistika/upisani-po-drzavama-za-univerzitet" component={EnrolledStudentsPerCountriesForUniversity} />
                    <Route path="/statistika/upisani-po-opcinama" component={EnrolledStudentsPerMunicipalityForBiH} />
                    <Route path="/statistika/upisani-po-opcinama-za-univerzitet" component={EnrolledStudentsPerMunicipalityForBiHForUniversity} />
                    <Route path="/statistika/upisani-po-studijskim-godinama-i-ciklusima" component={EnrolledStudentsPerStudyYearAndCycle} />
                    <Route path="/statistika/upisani-po-studijskim-godinama-i-ciklusima-za-univerzitet" component={EnrolledStudentsPerStudyYearAndCycleForUniversity} />


                </Switch>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Statistics/Router.js